import { Facility } from './facility';

export enum UserRole {
    SystemAdmin = 'system_admin',
    DepartmentAdmin = 'department_admin',
    FacilityAdmin = 'facility_admin',
    Student = 'student'
}

export enum ResidentAccountAction {
    'Download Usage Report (PDF)' = 'download',
    'Export Attendance' = 'export_attendance',
    'Transfer Resident' = 'transfer',
    'Delete Resident' = 'delete',
    'Deactivate Resident' = 'deactivate'
}

export enum FeatureAccess {
    ProviderAccess = 'provider_platforms',
    OpenContentAccess = 'open_content',
    ProgramAccess = 'program_management',
    LearningRecordAccess = 'learning_record',
    AiTutorAccess = 'ai_tutor',
    RequestContentAccess = 'request_content',
    HelpfulLinksAccess = 'helpful_links',
    UploadVideoAccess = 'upload_video',
    ResidentProgramsAccess = 'resident_programs'
}

export interface User {
    id: number;
    name_first: string;
    name_last: string;
    username: string;
    doc_id?: string | null;
    role: UserRole;
    email: string;
    password_reset?: boolean;
    session_id: string;
    created_at: string;
    updated_at: string;
    facility_id: number;
    facility: Facility;
    feature_access: FeatureAccess[];
    timezone: string;
    facilities?: Facility[];
    login_metrics: LoginMetrics;
    deactivated_at?: string | null;
    /** Canvas user's display name — populated by the mapped-users endpoint from the live provider API */
    canvas_name_first?: string;
    canvas_name_last?: string;
    [key: string]:
        | number
        | string
        | boolean
        | undefined
        | null
        | FeatureAccess[]
        | Facility[]
        | Facility
        | LoginMetrics;
}

export interface LoginMetrics {
    user_id: number;
    total: number;
    last_login: string;
}

export interface NewUserResponse {
    user: User;
    temp_password: string;
    kratos_registered: boolean;
}

export interface ResetPasswordResponse {
    temp_password: string;
    message: string;
}

export interface ValidResident {
    user: User;
    program_names: TransferResidentProgamConflicts[];
    trans_facility_id: number;
    transfer_to?: string;
    transfer_from?: string;
}

export interface TransferResidentProgamConflicts {
    program_name: string;
    class_name: string;
}

export interface ValidatedUserRow {
    row_number: number;
    last_name: string;
    first_name: string;
    resident_id: string;
    username: string;
}

export interface InvalidUserRow extends ValidatedUserRow {
    error_reasons: string[];
}

export interface BulkUploadResponse {
    valid_count: number;
    error_count: number;
    valid_rows: ValidatedUserRow[];
    invalid_rows: InvalidUserRow[];
    error_csv_data?: string;
}

export interface BulkPasswordResult {
    user_id: number;
    username: string;
    name: string;
    doc_id: string;
    temp_password: string;
}

export interface BulkPasswordResponse {
    successes: BulkPasswordResult[];
    failures: BulkActionFailure[];
}

export interface BulkActionFailure {
    user_id: number;
    username: string;
    name: string;
    reason: string;
}

export interface BulkActionResponse {
    success_count: number;
    failed_count: number;
    failures: BulkActionFailure[];
}

export enum FilterResidentNames {
    'Resident Name (A-Z)' = 'name_last asc',
    'Resident Name (Z-A)' = 'name_last desc'
}
